export default {
	methods: {
		getWeekNumber(date) {
			var tdt = new Date(date.valueOf());
			var dayn = (date.getDay() + 6) % 7;

			tdt.setDate(tdt.getDate() - dayn + 3);

			var firstThursday = tdt.valueOf();

			tdt.setMonth(0, 1);

			if (tdt.getDay() !== 4) {
				tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
			}

			return 1 + Math.ceil((firstThursday - tdt) / 604800000);
		},
		getFormattedDate(date, format) {
			var r = format;

			var rp = {
				d: date.getDate().toString().padStart(2, '0'),
				i: date.getMinutes().toString().padStart(2, '0'),
				H: date.getHours().toString().padStart(2, '0'),
				j: date.getDate(),
				Y: date.getFullYear(),
				m: (date.getMonth() + 1).toString().padStart(2, '0'),
				n: (date.getMonth() + 1)
			};

			for (var i in rp) {
				r = r.replace(i, rp[i]);
			}

			return r;
		}
	}
}